export const YoutubeIcon = ({ activeColor }: { activeColor?: string }) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            {/* Outer Rounded Rectangle */}
            <rect
                x="3"
                y="6"
                width="18"
                height="12"
                rx="4"
                stroke={activeColor}
                strokeWidth="2"
            />

            {/* Play Button */}
            <path
                d="M10 9.5L15 12L10 14.5V9.5Z"
                stroke={activeColor}
                strokeWidth="1.8"
                strokeLinejoin="round"
            />
        </svg>
    );
}